import * as THREE from 'three';
import { GLTFExporter } from 'three-stdlib';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter';
import { PLYExporter } from 'three/examples/jsm/exporters/PLYExporter';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter';
import { LoadedModel } from '../tabs/ThreeDTab';


export function ExportScene(loadedModels: LoadedModel[], format: 'gltf' | 'obj' | 'ply' | 'stl') {

    if (loadedModels.length === 0) {
        alert('No hay modelos cargados para exportar.');
        return;
    }

    const scene = new THREE.Scene();
    loadedModels.forEach(model => {
        scene.add(model.scene.clone());
    });

    if (format === 'gltf') {
        const exporter = new GLTFExporter();
        exporter.parse(
            scene,
            (result) => {
                const blob = new Blob([
                    result instanceof ArrayBuffer ? result : JSON.stringify(result)
                ], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'scene.gltf';
                link.click();
                URL.revokeObjectURL(url);
            },
            (error) => {
                console.error('Error exporting GLTF:', error);
            },  { binary: true }
        );
    } else if (format === 'obj') {
        const exporter = new OBJExporter();
        const result = exporter.parse(scene);
        const blob = new Blob([result], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'scene.obj';
        link.click();
        URL.revokeObjectURL(url);
    } else if (format === 'ply') {
        const exporter = new PLYExporter();
        exporter.parse(
            scene,
            (result: string | ArrayBuffer) => {
                const blob = new Blob([
                    result instanceof ArrayBuffer ? result : result
                ], { type: 'text/plain' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'scene.ply';
                link.click();
                URL.revokeObjectURL(url);
            },
            { binary: false } // Opciones para exportar en formato texto
        );
    } else if (format === 'stl') {
        const exporter = new STLExporter();
        const result = exporter.parse(scene);
        if (result) {
            const blob = new Blob([result], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'scene.stl';
            link.click();
            URL.revokeObjectURL(url);
        } else {
            console.error('Error exporting STL: Result is null.');
        }
    } else {
        alert('Formato no soportado.');
    }

}
